module.exports = __webpack_public_path__ + "static/media/banner-photo768@2x.ea25be97.webp";